import React, { useEffect, useState } from "react";
import { getFormattedAmount } from "../../../Utils";
import { getTotalSummaryData } from "../../../Services/DashboardService";
import { TOAST_MESSAGES } from "../../../Constants/Strings";
import * as Common from "../../../Components/Common";
import { useDashboard } from "../../../Context";
import toast from "react-hot-toast";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";

const TotalBillSummary = () => {
  const [billData, setBillData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { filters, getFormattedData } = useDashboard();

  const fetchBillData = async () => {
    try {
      const response = await getTotalSummaryData(getFormattedData());
      if (response.status === 200) {
        setBillData(response.data);
      } else {
        const msg = extractErrorMessage(response) || TOAST_MESSAGES.FAILED_lOAD;
        toast.error(msg);
      }
    } catch (error) {
      const msg = extractErrorMessage(error) || TOAST_MESSAGES.FAILED_lOAD;
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filters.user_id) {
      setLoading(true);
      fetchBillData().finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [filters]);

  return (
    <div className="grid grid-cols-3 md:grid-cols-3 gap-2 md:gap-8">
      <div className="bg-green-100 p-2 rounded-lg shadow-sm text-center">
        <h3 className="text-sm font-semibold">Approved</h3>
        <span className="text-sm font-bold h-6">
          {loading ? (
            <div className=" w-full flex justify-center">
              <Common.Spinner size={25} />
            </div>
          ) : (
            getFormattedAmount(billData?.approved || "0", 0)
          )}
        </span>
      </div>
      <div className="bg-blue-100 p-2 rounded-lg shadow-sm text-center">
        <h3 className="text-sm font-semibold">Pending</h3>
        <span className="text-sm font-bold h-6">
          {loading ? (
            <div className=" w-full flex justify-center">
              <Common.Spinner size={25} />
            </div>
          ) : (
            getFormattedAmount(billData?.pending || "0", 0)
          )}
        </span>
      </div>
      <div className="bg-red-200 p-2 rounded-lg shadow-sm text-center">
        <h3 className="text-sm font-semibold">Rejected</h3>
        <span className="text-sm font-bold h-6">
          {loading ? (
            <div className=" w-full flex justify-center">
              <Common.Spinner size={25} />
            </div>
          ) : (
            getFormattedAmount(billData?.rejected || "0", 0)
          )}
        </span>
      </div>
    </div>
  );
};
export default TotalBillSummary;
